// eslint-disable-next-line max-classes-per-file
import { AuthClient } from '../clients/AuthClient'
import { backendClient } from '../clients/client'
import { AdopterDto } from '../gen/backendClient'

export class LocalStorageToken {
  private static TOKEN_KEY = 'token'

  public static getCurrentToken(): string | null {
    return localStorage.getItem(this.TOKEN_KEY)
  }

  public static setToken(token: string): void {
    localStorage.setItem(this.TOKEN_KEY, token)
  }

  public static removeStaticToken(): void {
    localStorage.removeItem(this.TOKEN_KEY)
  }
}

export class AuthService {
  public static account?: AdopterDto = undefined

  public static async loginWithPassword(email: string, password: string): Promise<string> {
    const accessToken = await AuthClient.getAccessToken(email, password)

    LocalStorageToken.setToken(accessToken)
    this.attachAuthorizationToAllRequest(accessToken)
    await this.loadAccount()

    return accessToken
  }

  public static async loginWithGoogle(search: string): Promise<AdopterDto> {
    const accessToken = await AuthClient.getGoogleAccessToken(search)

    LocalStorageToken.setToken(accessToken)
    this.attachAuthorizationToAllRequest(accessToken)
    return await this.loadAccount()
  }

  public static async loginWithAccessToken(accessToken: string): Promise<AdopterDto> {
    LocalStorageToken.setToken(accessToken)
    this.attachAuthorizationToAllRequest(accessToken)
    return await this.loadAccount()
  }

  public static async tryLogInWithLocalToken(): Promise<AdopterDto | null> {
    console.log('tryLogInWithLocalToken')
    const token = LocalStorageToken.getCurrentToken()
    if (!token) {
      return null
    }

    this.attachAuthorizationToAllRequest(token)
    return await this.loadAccount()
  }

  public static async tryLoginWithGoogle(): Promise<void> {
    await backendClient.get('/adopters-platform/auth/google')
  }

  public static async register(email: string, password: string, fullname: string): Promise<AdopterDto | null> {
    const responseDto = await AuthClient.register(email, password, fullname)
    if (!responseDto.access_token) return null
    LocalStorageToken.setToken(responseDto.access_token)
    this.attachAuthorizationToAllRequest(responseDto.access_token)

    return this.loadAccount()
  }

  // public static logout(): void {
  //   localStorage.removeItem('user')
  // }

  public static isLogged(): boolean {
    return Boolean(this.account)
  }

  // public static isLoggedAsAdmin(): boolean {
  //   return !!this.account && this.account.roles.includes('forto-admin')
  // }

  public static async loadAccount(): Promise<AdopterDto> {
    const responseDto = await AuthClient.getCurrentAccount()
    this.account = responseDto

    return responseDto
  }

  public static async logout(): Promise<void> {
    LocalStorageToken.removeStaticToken()
    this.attachAuthorizationToAllRequest('')
    this.account = undefined
    window.location.reload()
  }

  public static async requestPasswordReset(email: string) {
    await AuthClient.requestPasswordReset(email)
  }

  private static authorizationInterceptorId?: number

  private static attachAuthorizationToAllRequest(token: string): void {
    // Request interceptors run last registered first: a previous one left in place would have the final word and
    // overwrite the new token with the one of the former session.
    if (this.authorizationInterceptorId !== undefined) {
      backendClient.interceptors.request.eject(this.authorizationInterceptorId)
    }

    this.authorizationInterceptorId = backendClient.interceptors.request.use((config) => {
      if (!config) {
        throw new Error('Config undefined')
      }

      if (!config.url?.includes('auth')) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, no-param-reassign
        config.headers!.Authorization = `Bearer ${token}`
      }

      return config
    })
  }
}
